// global
export const SAVE_ERROR = "SAVE_ERROR"
export const LOADING_START = "LOADING_START"
export const LOADING_END = "LOADING_END"
// related to modules
export const SAVE_NOTIFICATIONS = "SAVE_NOTIFICATIONS"
export const SAVE_NOTIFICATION = "SAVE_NOTIFICATION"

